import { render, staticRenderFns } from "./ser_trajectory.vue?vue&type=template&id=204bd457&scoped=true&"
import script from "./ser_trajectory.vue?vue&type=script&lang=js&"
export * from "./ser_trajectory.vue?vue&type=script&lang=js&"
import style0 from "./ser_trajectory.vue?vue&type=style&index=0&id=204bd457&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204bd457",
  null
  
)

export default component.exports